import { Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CalculationStatus } from "@sharedcommon/model/calculation-status.model";
import { CalculationStatusService } from "@usercommon/service/calculation-status.service";

@Component({
  selector: 'calculation-status-icon',
  templateUrl: './calculation-status-icon.component.html',
  styleUrls: [ 'calculation-status-icon.component.scss' ]
})
export class CalculationStatusIconComponent {
  @Input() status: CalculationStatus ;
  @Input() tooltipMode: boolean ;
  @Input() inTable: boolean ;

  private readonly calcStatusToBackgroundColor: Map<CalculationStatus, string> = new Map<CalculationStatus, string>([
    [ CalculationStatus.BlockBeforeCalc, "red" ],
    [ CalculationStatus.BlockAfterCalc, "darkorange" ],
    [ CalculationStatus.Valid, "#8BC400" ],
    [ CalculationStatus.WaitingForCalculation, "grey"]
  ]);

  constructor(private readonly translateService: TranslateService) {}

  getIconBackgroundColor(): string {
    return (this.status || '') && this.calcStatusToBackgroundColor.get(this.status) ;
  }

  getTooltipMessage(): string {
    return this.tooltipMode ?
                this.translateService.instant(this.getStatusDescription())
                : null ;
  }

  getTextAlign(): string {
    return this.inTable ? 'left' : 'center' ;
  }

  getStatusDescription(): string {
    return this.translateService.instant(CalculationStatusService.returnCalculationStatusKeyMsg(this.status)) ;
  }
}
